import * as z from 'zod';

export const OtherSchema = z.object({
  unvisitedRooms: z.string().optional(), // text area
  extraDescription: z.string().optional(),
});

export type Other = z.infer<typeof OtherSchema>;
